
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class TrainBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class TrainBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `${data.n}-${data.d} [ ${data.src.n} - ${data.dst.n} ] ${data.tp}-${data.u}`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'train',
      children:        args.children,
      parent:          args.parent,
      actualMoves:     [],
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      uuid:            data.u,
      trainTemplateId: data._pid,
      kind:            data.tp,
      direction:       data.d,
      source: {
        name:          data.src.n,
        mileage:       data.src.m
      },
      destination: {
        name:          data.dst.n,
        mileage:       data.dst.m
      },
      trainClass:      data.tc,
      tonnage:         data.ton,
      length:          data.l,
      priority:        data.pri,
      overtake:        data.o,
      u:               data._id
    };

  }
}
